import React, { useState } from "react";
import DisplayLayout from "../../components/layout/DisplayLayout";
import ListItem from "./ListItem";
import donations from "../../data/donations";
import { BsFillCaretLeftFill, BsFillCaretRightFill } from "react-icons/bs";

const handleColor = (index) => {
  if (1 % index === 0) return "#1CD5C5";
  else if (2 % index === 0) return "#4B92A8";
  else if (3 % index === 0) return "#FFCCA5";
  else if (4 % index === 0) return "#FEFAEE";
  else return "#4BB1CE";
};

const Home = () => {
  let showPerPage = 4;
  const [page, setPage] = useState(0);

  showPerPage = page === 0 ? showPerPage : showPerPage + page;

  const updateDonations = donations.slice(0, -1).slice(page, showPerPage);

  return (
    <DisplayLayout mainBg="#4BB1CE" footerBg="#D3EAF2">
      <div className="bg-white absolute z-40 shadow-home ksm:h-[90%] ksm:w-[90%] overflow-hidden ksm:rounded-[15px] kmd:rounded-[25px] klg:rounded-[40px] ">
        <div className=" bg-gradient-to-t from-white to-[#bef0ec] p-10 klg:p-24 ">
          <div className="flex justify-between ">
            <img
              className="mt-12 w-[20%] h-[20%]"
              src="/logo/pair-logo.png"
              alt=""
            />
            <div className="uppercase ksm:text-[70px] kmd:text-[105px] klg:text-[160px] kxl:text-[200px] font-extrabold pr-10  text-right text-[#126178]">
              <h2>DONATE</h2>
              <h2 className="ksm:leading-10 ">HERE</h2>
            </div>
          </div>
        </div>
        <div className="ksm:p-5 kmd:p-10 klg:p-20 ">
          <div className="ksm:mt-8 kmd:mt-12 klg:mt-16  flex justify-between items-center">
            <div>
              <h6 className="uppercase ksm:text-[25px] kmd:text-[30px] klg:text-[45px] kxl:text-[80px] font-bold  font-montserrat">
                Al-Masjid Al-Jamie, Ponsonby
              </h6>
              <h4 className="uppercase ksm:text-[20px] kmd:text-[40px] klg:text-[55px] kxl:text-[90px] font-normal  underline">
                CURRENT APPEALS
              </h4>
            </div>
            <div className="ksm:h-12 kmd:h-24 klg:h-32 kxl:h-40">
              <img
                className="h-full "
                src="/logo/donation-logo.png"
                alt="Fund_a_chairty"
              />
            </div>
          </div>
          <div className="ksm:mt-10 kmd:mt-20 klg:mt-40 grid grid-cols-1 ksm:gap-8 kmd:gap-10 klg:gap-16 kxl:gap-24">
            {updateDonations.map((donation, index) => (
              <ListItem
                key={index}
                index={index}
                color={handleColor(index)}
                donation={donation}
              />
            ))}
          </div>
        </div>
      </div>
      {/* More Button access */}
      <div className="absolute bottom-[30px] klg:bottom-[35px] z-40 flex items-center justify-between w-[90%] kmd:w-[87%]">
        {page > 0 ? (
          <button
            className="py-1 klg:py-3 px-2 klg:px-6 flex items-center justify-center gap-x-1 ksm:text-lg kmd:text-xl klg:text-4xl font-semibold uppercase rounded bg-custom-yellow-300 text-gray-800 focus:outline-none focus:ring-4 focus:ring-custom-yellow-300"
            onClick={() => setPage(page - 4)}
          >
            <BsFillCaretLeftFill size={25} />
            Back
          </button>
        ) : (
          <span></span>
        )}

        {donations.length - 1 > showPerPage && (
          <button
            className="py-1 klg:py-3 px-2 klg:px-6 flex items-center justify-center gap-x-1 ksm:text-lg kmd:text-xl klg:text-4xl font-semibold uppercase rounded bg-custom-yellow-300 text-gray-800 focus:outline-none focus:ring-4 focus:ring-custom-yellow-300"
            onClick={() => setPage(page + 4)}
          >
            More
            <BsFillCaretRightFill size={25} />
          </button>
        )}
      </div>
    </DisplayLayout>
  );
};

export default Home;
